import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface UnemploymentState {}

const state = (): UnemploymentState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createUnemploymentApplication(
    { commit }: { commit: Commit },
    data: any
  ) {
    const endpoint = "/application/unemployment";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getUnemploymentTypes() {
    const endpoint = "/application/unemployment/types";

    const res = await http.get(endpoint);

    return res.data;
  },
  async checkEligibility() {
    const endpoint = "/application/unemployment/eligibility";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
